<div class="wrapper">
    <header class="p-headline-6 p-tpgr-bold" attr.automation-id="multiColumns_ColumnHeader_{{ column.header | translate }}">
        <p-icon [name]="column.icon"></p-icon>
        <span>{{ column.header | translate }}</span>
    </header>
    <div class="data">
        <div *ngFor="let item of column.items" class="data-item" [matTooltip]="item.label" [showOnlyWhenEllipsis]="true" matTooltipClass="p-tooltip2">
            <a
                class="item-text p-tpgr-regular p-paragraph-1"
                [routerLink]="item.routePath"
                (click)="close.emit($event)"
                attr.automation-id="dropDownMenuItem_{{ item.label }}"
            >
                {{ item.label }}</a
            >
        </div>
    </div>
    <footer class="footer">
        <div class="divider" [style.visibility]="column.footer ? 'visible' : 'hidden'"></div>
        <a
            class="item-text p-paragraph-1 p-tpgr-semibold"
            [routerLink]="column.footerRoutePath"
            (click)="close.emit($event)"
            attr.automation-id="columnSummary_{{ column.footer | translate }}"
        >
            {{ column.footer | translate }}
        </a>
    </footer>
</div>
